import Validations from "@/util/Validations"
import { readFile } from "@/util/utils"

export default async function ({file, config, jsonLinesSize, headerFields}) {

    let fileContent = await readFile(file)
    let allLines = fileContent.split(/\r\n|\n/)

    for (let i = 0; i < allLines.length; i++) {
        allLines[i] = allLines[i].split(";")
    }


    function parserCSVLine(line) {
        let rowJson = {}
        let rowCsv = allLines[line]

        if (!rowCsv) {
            return rowJson
        }

        headerFields.forEach(headerField => {
            let fieldKey = headerField.key

            if (fieldKey == "line")
                return

            let columnNumber = config.estruturaColunas[fieldKey]
            let value = rowCsv[columnNumber - 1]

            if (value == "")
            {
                value = null
            }

            rowJson[fieldKey] = value
        })

        return rowJson
    }

    return function parseLines (lineStart) {

        let list = []
        let lastBatch = false

        if (!allLines) {
            return null
        }

        let start = lineStart - 1 //csv start from zero
        let end = start + jsonLinesSize

        for (let line = start; line < end; line++)
        {
            let rowJson = parserCSVLine(line)
            let nextRowJson = parserCSVLine(line+1)

            if (Validations.isEmpty(rowJson))
            {
              if(Validations.isEmpty(nextRowJson))
              {
                lastBatch = true
                break
              }

              continue;
            }
            else
            {
                rowJson.id = {line: line + 1} //for table id in data base
                rowJson.line = rowJson.id.line //only for presentation

                list.push(rowJson)
            }
        }

        return {list, lastBatch}
    }
}